export enum ProfileManagementPermissions {
  VIEW_PROFILE_MANAGEMENT = "view_profile_management",
  CREATE_PROFILE_MANAGEMENT = "create_profile_management",
  UPDATE_PROFILE_MANAGEMENT = "update_profile_management",
  DELETE_PROFILE_MANAGEMENT = "delete_profile_management",
  ARCHIVE_PROFILE_MANAGEMENT = "archive_profile_management",
}

export const ProfileManagementPermissionsText: Record<
  ProfileManagementPermissions,
  string
> = {
  [ProfileManagementPermissions.VIEW_PROFILE_MANAGEMENT]:
    "View Profile Management",
  [ProfileManagementPermissions.CREATE_PROFILE_MANAGEMENT]:
    "Create Profile Management",
  [ProfileManagementPermissions.UPDATE_PROFILE_MANAGEMENT]:
    "Update Profile Management",
  [ProfileManagementPermissions.DELETE_PROFILE_MANAGEMENT]:
    "Delete Profile Management",
  [ProfileManagementPermissions.ARCHIVE_PROFILE_MANAGEMENT]:
    "Archive Profile Management",
};
